// Vanilla JS modal (replaces modal.coffee)
export function initModals() {
  document.querySelectorAll('.modal').forEach((trigger) => {
    trigger.addEventListener('click', (e) => showModal(e, trigger));
  });
}

function showModal(event, triggerEl) {
  event.preventDefault();

  const overlay = document.createElement('div');
  overlay.className = 'overlay';

  const modal = document.createElement('div');
  modal.className = 'modal-box default';

  const modalBody = document.createElement('div');
  modalBody.className = 'modal-body';

  const close = document.createElement('a');
  close.className = 'close';
  close.href = '#';
  close.textContent = 'Close';

  const closeModal = () => {
    modal.remove();
    overlay.remove();
  };

  overlay.addEventListener('click', closeModal);
  close.addEventListener('click', (e) => {
    e.preventDefault();
    closeModal();
  });

  const isRemote = triggerEl.getAttribute('data-remote') !== null;

  if (isRemote) {
    fetch(triggerEl.getAttribute('href'))
      .then((r) => r.text())
      .then((html) => {
        modalBody.innerHTML = html;
      });
  } else {
    const templateId = triggerEl.getAttribute('data-modal');
    const template = document.getElementById(templateId);
    if (template) {
      modalBody.innerHTML = template.innerHTML;
      const modalClass = template.getAttribute('class');
      if (modalClass) modal.classList.add(modalClass);
    }
  }

  modal.appendChild(modalBody);
  modal.appendChild(close);
  document.body.appendChild(modal);
  document.body.appendChild(overlay);

  const windowHeight = window.outerHeight;
  const windowWidth = window.outerWidth;
  const modalHeight = modal.offsetHeight;
  const modalWidth = modal.offsetWidth;
  modal.style.left = (windowWidth - modalWidth) / 2 + 'px';
  modal.style.top = (windowHeight - modalHeight) / 2 + 'px';
}
